import { useTranslation } from 'react-i18next';
import { Badge } from '@heroui/react/badge';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ds';
import { useTour } from './tour-context';

/**
 * The Topbar's "Tour" control. Present only on a page that has a tour, and
 * marked with a dot until that page's tour has been taken once on this device.
 *
 * Icon alone on phones, the same way the language menu beside it collapses.
 */
export function TourButton() {
  const { t, i18n } = useTranslation();
  const { available, seen, start } = useTour();
  if (!available) return null;

  return (
    <Badge.Anchor>
      <Button
        variant="ghost"
        size="sm"
        data-tour="tour-button"
        aria-label={t('tour.start')}
        title={t('tour.start')}
        onPress={start}
        startIcon={<Compass aria-hidden className="size-icon shrink-0" />}
        className="min-w-control text-secondary-500 hover:text-secondary-800"
      >
        <span className="hidden sm:inline">{t('tour.button')}</span>
      </Button>
      {!seen && (
        <Badge
          aria-hidden
          color="accent"
          size="sm"
          // HeroUI places badges by physical corner; the dot belongs at the
          // reading end of the button.
          placement={i18n.dir() === 'rtl' ? 'top-left' : 'top-right'}
          className="pointer-events-none size-2.5 min-h-0 min-w-0"
        />
      )}
    </Badge.Anchor>
  );
}
